export default __webpack_public_path__ + "static/media/chat.7c4c4b9b.svg";